module.exports = {
  email: 'brookkasahun@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/brook1717',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/biruk-kasahun-684b682a6/',
    },
    {
      name: 'Twitter',
      url: 'https://x.com/birukksahun',
    },
    
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/', // TODO: Replace with your real Instagram profile URL
    },
    {
     name: 'Devto',
     url: 'https://dev.to/', // TODO: Replace with your real Dev.to profile URL (e.g. https://dev.to/yourhandle)
   },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'The Stack',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  // Inside src/config.js (approximately)
colors: {
  green: '#38bdf8',
  navy: '#0f172a',
  darkNavy: '#020c1b', // or your preferred deepest shade
},

  srConfig: (delay = 200, viewFactor = 0.15) => ({
    origin: 'bottom',
    distance: '24px',
    duration: 600,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
